/** Écran de connexion « Continuer avec Rayor ». */
import { el, clear } from '../ui/dom.js';

const RAYOR_ICON = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2 2 7v5c0 5 4 8.5 10 10 6-1.5 10-5 10-10V7L12 2Z" fill="currentColor" opacity="0.18"/>
  <path d="M12 2 2 7v5c0 5 4 8.5 10 10 6-1.5 10-5 10-10V7L12 2Z" stroke="currentColor" stroke-width="1.6"/>
  <circle cx="12" cy="10" r="2.4" fill="currentColor"/>
  <path d="M8.2 16c.4-2 1.9-3 3.8-3s3.4 1 3.8 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
</svg>`;

export function renderLogin(config = {}) {
  const app = document.getElementById('app');
  app.removeAttribute('aria-busy');

  const rayorBtn = el('a', { class: 'rayor-btn', href: '/auth/login', html: RAYOR_ICON + '<span>Continuer avec Rayor</span>' });

  const panel = el('div', { class: 'glass panel' },
    el('img', { class: 'logo', src: '/assets/logo.svg', alt: 'JHN' }),
    el('h1', {}, 'JHN Suite'),
    el('p', {}, 'Votre espace de travail collaboratif. Connectez-vous pour accéder à vos documents, feuilles, présentations, agenda et tâches.'),
    rayorBtn,
    config.allowDevLogin
      ? el('div', { class: 'dev' }, 'Mode développement — ',
          el('a', { href: '/auth/dev-login?u=1' }, 'Johan'), ' · ',
          el('a', { href: '/auth/dev-login?u=2' }, 'Camille'))
      : '',
    el('div', { class: 'foot' }, 'Propulsé par Rayor Connect · ', el('a', { href: 'https://connect.rayor.fr', target: '_blank', style: { color: 'var(--text-faint)' } }, 'connect.rayor.fr'))
  );

  clear(app).appendChild(el('div', { class: 'login fade-in' }, panel));
}
